import { roundNumber } from './utils';

/**
 * La API v3 identifica el job del alumno con `id` y la v2 con `guid` (columna real de `lms_course_students_jobs`).
 * Si el job trae alguna de las dos, se copia en la otra para que ningún consumidor dependa de la rama que produjo
 * el item; `id` manda cuando vienen ambas (misma precedencia que tenía el servicio). Un job sin ninguna se
 * devuelve tal cual.
 * @param {Object|null|undefined} job
 * @returns {Object|null} El job con `id` y `guid`, o `null` si no hay job
 */
export function normalizeJob(job) {
  if (!job) {
    return null;
  }
  const guid = job.id ?? job.guid;
  return guid ? { ...job, guid, id: guid } : job;
}

export function renderProgress(progress) {
  let jobProgress = 0;
  if (progress) {
    jobProgress = progress * 100 > 100 ? 100 : progress * 100;
    try {
      if (jobProgress && jobProgress.toString().length > 2) jobProgress = roundNumber(jobProgress);
    } catch {
      // Ignore rounding errors
    }
  }

  return jobProgress;
}

/**
 * Check if a job has been finished (delivered or evaluated)
 * @param {Object} job - The job object to check
 * @returns {boolean} True if the job status is 'delivered' or 'evaluated'
 */
export function isJobFinished(job) {
  if (!job) {
    return false;
  }
  return job.status === 'delivered' || job.status === 'evaluated';
}

/**
 * Get frozen questions from job's frozen assessment data, with fallback to fresh questions
 * @param {Object} selectedJob - The job object that may contain freezed_assessment_data
 * @param {Array} questions - Fresh questions array to use as fallback
 * @returns {Array} Frozen questions if available, otherwise fresh questions
 */
export function getFrozenQuestions(selectedJob, questions) {
  if (selectedJob?.freezed_assessment_data) {
    try {
      const freezedData = JSON.parse(selectedJob.freezed_assessment_data);
      if (freezedData?.questions) {
        return freezedData.questions;
      }
    } catch (error) {
      console.warn('Failed to parse frozen assessment data:', error);
    }
  }
  return questions;
}
